import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Home from "./pages/Home";
import PublicAuth from "./PublicAuth";
import WallpaperPrivacyPolicy from "./pages/Configurations/wallpaper/WallpaperPrivacyPolicy";
import ShayariPrivacyPolicy from "./pages/Configurations/Shayari/ShayariPrivacyPolicy";
import DeleteAccount from "./pages/Configurations/Shayari/DeleteAccount";
import GkPrivacyPolicy from "./pages/Configurations/generalKnowledge/GkPrivacyPolicy";
import NcertPrivacyPolicy from "./pages/Configurations/ncertSolutions/NcertPrivacyPolicy";
import ChemistryPrivacyPolicy from "./pages/Configurations/chemistry/ChemistryPrivacyPolicy";
import ChemistryDeleteAccount from "./pages/Configurations/chemistry/DeleteAccount";
import WallpaperDeleteAccount from "./pages/Configurations/wallpaper/DeleteAccount";
import GkDeleteAccount from "./pages/Configurations/generalKnowledge/DeleteAccount";
import TestSetuDeleteAccount from "./pages/Configurations/TestSetu/DeleteAccount";
import DeleteAccounts from "./pages/DeleteAccounts";
import MathematicsPrivacyPolicy from "./pages/Configurations/mathematics/MathematicsPrivacyPolicy";
import PhysicsPrivacyPolicy from "./pages/Configurations/physics/PhysicsPrivacyPolicy";
import PianoPrivacyPolicy from "./pages/Configurations/piano/PianoPrivacyPolicy";
import DocumentScanner from "./pages/Configurations/documentScanner/DocumentScanner";

// Reference: https://crave-template.webflow.io/reservation

function App() {
  return (
    <BrowserRouter>
      {/* <AuthProvider> */}
      <ToastContainer
        position="bottom-center"
        autoClose={4000}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        {/* Public Auth */}
        <Route path="/" element={<PublicAuth />}>
          <Route path="" element={<Home />} />
        </Route>
        <Route
          path="wallpaper/privacyPolicy"
          element={<WallpaperPrivacyPolicy />}
        />
        <Route
          path="wallpaper/deleteAccount"
          element={<WallpaperDeleteAccount />}
        />
        <Route path="gk/deleteAccount" element={<GkDeleteAccount />} />
        <Route
          path="testsetu/deleteAccount"
          element={<TestSetuDeleteAccount />}
        />
        <Route path="delete-accounts" element={<DeleteAccounts />} />
        <Route
          path="shayari/privacyPolicy"
          element={<ShayariPrivacyPolicy />}
        />
        <Route path="shayari/deleteAccount" element={<DeleteAccount />} />
        <Route path="gk/privacyPolicy" element={<GkPrivacyPolicy />} />
        <Route path="ncert/privacyPolicy" element={<NcertPrivacyPolicy />} />
        <Route
          path="chemistry/privacyPolicy"
          element={<ChemistryPrivacyPolicy />}
        />
        <Route
          path="chemistry/deleteAccount"
          element={<ChemistryDeleteAccount />}
        />
        <Route
          path="mathematics/privacyPolicy"
          element={<MathematicsPrivacyPolicy />}
        />
        <Route
          path="physics/privacyPolicy"
          element={<PhysicsPrivacyPolicy />}
        />
        <Route path="piano/privacyPolicy" element={<PianoPrivacyPolicy />} />
        <Route
          path="documentScanner/privacyPolicy"
          element={<DocumentScanner />}
        />
      </Routes>
      {/* </AuthProvider> */}
    </BrowserRouter>
  );
}

export default App;
